import { Alert } from "@mantine/core";
import React from "react";
import DateCountDown from "../DateCountDown";
import { HSpace } from "../index";

const formatScheduledBatchJob = (value: string): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("nb-NO", {
    weekday: "long",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
};

const BatchJobSettingsBanner: React.FC<{
  nrOfSettingsComplete: number;
  totalNumberOfSettings: number;
  nextScheduledBatchJob: string;
}> = ({ nrOfSettingsComplete, totalNumberOfSettings, nextScheduledBatchJob }) => {
  return (
    <>
      {nrOfSettingsComplete !== totalNumberOfSettings ? (
        <Alert color="yellow" variant="light">
          <b>
            {nrOfSettingsComplete} av {totalNumberOfSettings} innstillinger er utført
          </b>
        </Alert>
      ) : (
        <Alert color="green" variant="light" className="d-flex">
          {nextScheduledBatchJob != null && (
            <>
              <span className="d-flex">
                Den neste batchjobben er planlagt
                <HSpace />
                <b>{formatScheduledBatchJob(nextScheduledBatchJob)}</b>
              </span>

              <div className="flex-fill" />
              <DateCountDown date={new Date(nextScheduledBatchJob)} />
            </>
          )}
        </Alert>
      )}
    </>
  );
};

export default BatchJobSettingsBanner;
